import React from 'react';
import NuevoProyecto from '../proyectos/NuevoProyecto';
import ListadoProyectos from '../proyectos/ListadoProyectos';
import { FcFolder } from "react-icons/fc";

const Sidebar = () => {
    return ( 
        <aside>
            <h1>Foro<span>Críticas</span></h1>

            <NuevoProyecto />

            <div className="proyectos">
                
                <h2><FcFolder/> Tus Carpetas</h2>
                <ListadoProyectos />
                {/* <button>Buscar critica</button> */}
            </div>
        </aside>
     );
}
 
export default Sidebar;